import { Injectable } from '@angular/core';
import { type Observable } from 'rxjs';

import { BaseHttpService } from '@common/services/REST/base.http.service';

export type CaptchaLimitWidget = {
    id: string;
    minutes: number;
    attempts: number;
};

@Injectable({
    providedIn: 'root',
})
export class CaptchaLimitsHttpService extends BaseHttpService {
    public setCaptchaLimits(siteId: string, pageId: string, widgets: CaptchaLimitWidget[]): Observable<any> {
        return this.http.post<any>(this.formatApiUrl(`sites/${siteId}/pages/${pageId}/rate-limits`), {
            widgets,
        });
    }

    public deleteCaptchaLimits(
        siteId: string,
        pageId: string,
        widgets: { id: string; attempts: number }[]
    ): Observable<any> {
        return this.http.post<any>(this.formatApiUrl(`sites/${siteId}/pages/${pageId}/rate-limits`), {
            widgets,
        });
    }
}
